import { Alert } from '@shared/components';

export default function ItemSetApplyConditionErrorAlert() {
  return (
    <Alert
      severity='error'
      sx={(theme) => ({
        ...theme.typography.body1,
      })}
    >
      ไม่สามารถแสดงจำนวนข้อสอบได้ เนื่องจากยังไม่ได้ตรวจสอบเงื่อนไข (Apply Conditions)
    </Alert>
  );
}
